// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2spGj","label":"styles_label__3KkMS"};